import React, { Component } from 'react';
import classnames from "classnames"
import cookies from "./cookies"

import SnackbarContainer from "./Components/SnackbarContainer"

import { Route, Redirect, Link } from "react-router-dom";

import Header from "./Header.js"

import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

// Routes
import Welcome from "./Routes/Welcome"

import Mitarbeiter from "./Routes/Mitarbeiter/index"
import MitarbeiterDetail from "./Routes/Mitarbeiter/Detail"

import Fuhrpark from "./Routes/Fuhrpark/index"
import FuhrparkDetail from "./Routes/Fuhrpark/Detail"

import Kontakte from "./Routes/Kontakt/index"
import KontaktDetail from "./Routes/Kontakt/Detail"

import Fahrplan from "./Routes/Fahrplan/index"
import FahrplanDetail from "./Routes/Fahrplan/Detail"

import Umlaufplaene from "./Routes/Umlaufplaene/index"
import UmlaufplaeneDetail from "./Routes/Umlaufplaene/Detail"

import Dienstplan from "./Routes/Dienstplan/index"

import Farbzuordnung from "./Routes/Farbzuordnung/index"
import FarbzuordnungDetail from "./Routes/Farbzuordnung/Detail"

import BesondererDienst from "./Routes/BesondererDienst/index"
import BesondererDienstDetail from "./Routes/BesondererDienst/Detail"

import Zeitraum from "./Routes/Zeitraum/index"
import ZeitraumDetail from "./Routes/Zeitraum/Detail"

import Parameter from "./Routes/Parameter/index"
import ParameterDetail from "./Routes/Parameter/Detail"

import Verkehrshinweis from "./Routes/Verkehrshinweis/index"
import VerkehrshinweisDetail from "./Routes/Verkehrshinweis/Detail"

import Kalender from "./Routes/Kalender/index"
import KalenderDetail from "./Routes/Kalender/Detail"

import Sonderfahrt from "./Routes/Sonderfahrt/index"
import System from "./Routes/System/index"

import AbteilungDetail from "./Routes/Abteilungen/Detail"
import FunktionDetail from "./Routes/Funktion/Detail"
import BetriebsstaettenDetail from "./Routes/Betriebsstaetten/Detail"

import Monatsuebersicht from "./Routes/Monatsuebersicht/index"
import Zeiterfassung from "./Routes/Zeiterfassung/index"

import UsersDetail from "./Routes/User/Detail"

import LogoChr from "./assets/logo-chr.png"

// Icons
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import * as Sentry from '@sentry/browser';

const drawerWidth = 240;

const styles = theme => ({
    palette: {
        primary: {
            main: "#0165a1",
            light: "#eee",
            dark: "#eee",
        },
    },
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing.unit * 3,
        paddingTop: "90px",
        height: "calc(100vh - 115px)",
        overflow: "auto"
    },
    logoHeight: {
        height: "60px"
    },
    logoBar: {
        paddingLeft: 4,
        backgroundColor: "#0165a1"
    },
    flex: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-start",
        flexBasis: "auto",
        flex: "auto"
    },
    logout: {
        flexGrow: 1,
        textAligt: "right"
    }
});

class App extends Component {

    state = {
        authSuccess: false,
        open: false,
        current: window.location.pathname.replace("/", ""),
        auth: undefined,
        doOpen: {},
        anchorEl: undefined
    }

    constructor(props) {
        super(props)
        this.state.auth = cookies.get("auth")
    }


    componentDidCatch(error, errorInfo) {
      this.setState({ error });
      Sentry.withScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    }

    getOptions = (name) => {
        if(this.state.current === name) {
            return {
                color: "primary",
                variant: "raised"
            }
        }
    }

    setOption = (current) => {
        this.setState({
            current
        })
    }

    handleClose = (key, title) => {
        this.state.doOpen[key] = false
        if(title!==undefined) {
            this.setOption(title)
            return
        }
        this.setState({})
    }

    handleClick = (key, event) => {
        this.state.doOpen[key] = true
        this.setState({ anchorEl: event.currentTarget });
    }

    start = () => {

    }

    ende = () => {
        
    }

    render() {

        const { classes } = this.props
        var { auth } = this.state

        if (cookies.get("auth") === undefined) {
            return <Redirect to={"/login"} />;
        }

        return (
            <div className={classes.root}>

                <SnackbarContainer />

                <Header />


                <main className={classes.content}>
                    <div className={classes.toolbar} />

                    <Route startsWith exact path="/" component={Welcome} />
                    <Route startsWith exact path="/system" component={System} />
                    <Route startsWith exact path="/sonderfahrt" component={Sonderfahrt} />
                    <Route startsWith exact path="/monatsuebersicht" component={Monatsuebersicht} />
                    
                    <Route startsWith exact path="/zeiterfassung" component={Zeiterfassung} />

                    <Route startsWith exact path="/kalender" component={Kalender} />
                    <Route startsWith path="/kalender/:id" component={KalenderDetail} />
                    
                    <Route startsWith exact path="/mitarbeiter" component={Mitarbeiter} />
                    <Route startsWith path="/mitarbeiter/:id" component={MitarbeiterDetail} />

                    <Route startsWith exact path="/dienstplan" component={Dienstplan} />

                    <Route startsWith exact path="/fahrplan" component={Fahrplan} />
                    <Route startsWith path="/fahrplan/:id" component={FahrplanDetail} />

                    <Route startsWith exact path="/umlaufplan" component={Umlaufplaene} />
                    <Route startsWith exact path="/umlaufplan/:id" component={UmlaufplaeneDetail} />

                    <Route startsWith exact path="/fuhrpark" component={Fuhrpark} />
                    <Route startsWith path="/fuhrpark/:id" component={FuhrparkDetail} />

                    <Route startsWith exact path="/kontakte" component={Kontakte} />
                    <Route startsWith path="/kontakte/:id" component={KontaktDetail} />

                    <Route startsWith exact path="/farbzuordnung" component={Farbzuordnung} />
                    <Route startsWith path="/farbzuordnung/:id" component={FarbzuordnungDetail} />

                    <Route startsWith exact path="/besondererDienst" component={BesondererDienst} />
                    <Route startsWith path="/besondererDienst/:id" component={BesondererDienstDetail} />

                    <Route startsWith exact path="/parameter" component={Parameter} />
                    <Route startsWith path="/parameter/:id" component={ParameterDetail} />

                    <Route startsWith exact path="/zeitraum" component={Zeitraum} />
                    <Route startsWith path="/zeitraum/:id" component={ZeitraumDetail} />

                    <Route startsWith exact path="/verkehrshinweis" component={Verkehrshinweis} />
                    <Route startsWith path="/verkehrshinweis/:id" component={VerkehrshinweisDetail} />

                    <Route startsWith path="/users/:id" component={UsersDetail} />
                    <Route startsWith path="/abteilungen/:id" component={AbteilungDetail} />
                    <Route startsWith path="/funktion/:id" component={FunktionDetail} />
                    <Route startsWith path="/betriebsstaetten/:id" component={BetriebsstaettenDetail} />

                </main>

            </div>
        );
    }
}

// <Route exact path="/entries" component={Entries} />

export default withStyles(styles, { withTheme: true })(App);



// WEBPACK FOOTER //
// ./src/App.js